import template from './new-custom-theme.html';
import themes from '../themes/themes';

export default {
	name: 'NewCustomTheme',
	template,
	props: ['theme', 'data', 'backgroundUrl', 'fontFamily', 'customRowClasses', 'popupCall'],
	data () {
		return {
			themes,
			queue: {
				data: []
			},
			isFullscreenBlink: false,
			blinkItem: {}
		};
	},
	watch: {
		data (newVal, oldVal) {
			clearTimeout(this.popupCallTimeout);
			this.isFullscreenBlink = false;
			const queue = newVal[0] || {data: []};
			this.blinkItem = queue.data.find((v) => v.blink === true);
			this.isFullscreenBlink = Boolean(this.blinkItem);
			if (this.isFullscreenBlink) {
				this.popupCallTimeout = setTimeout(() => {
					this.isFullscreenBlink = false;
				}, 2500);
			}

			this.queue = queue;
		}
	},
	methods: {
		applyStyle (styleDef) {
			const style = document.createElement('style');
			style.type = 'text/css';
			document.head.appendChild(style);
			style.innerHTML = styleDef;
		}
	},
	created () {
		if (this.customRowClasses !== '') {
			this.applyStyle(this.customRowClasses);
		}

		if (this.popupCall.classes !== '') {
			this.applyStyle(this.popupCall.classes);
		}
	}
};
